import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost, apiPut } from '../api';
import {
  ICreateToolInspectionReportUrlRes,
  IToolInformationTabRes,
  ISetToolInspectionReq
} from 'types/suscription/toolInspection.types';

const { REACT_APP_SUBSCRIPTION } = process.env;

export const getToolInformationTab = async (productId: number): Promise<IToolInformationTabRes> => {
  return apiGet<AxiosRequestConfig, IToolInformationTabRes>(
    `${REACT_APP_SUBSCRIPTION}/backoffice-tools-view/internal/tool-information/${productId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const createToolInspectionReportUrl = async (productId: string): Promise<string> => {
  return apiPost<AxiosRequestConfig, ICreateToolInspectionReportUrlRes>(
    `${REACT_APP_SUBSCRIPTION}/tool-inspection-information/generate-report/by-product-id/${productId}`
  )
    .then(response => Promise.resolve(response?.data?.url))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const setToolInspection = async (body: ISetToolInspectionReq): Promise<void> => {
  return apiPut<AxiosRequestConfig, ISetToolInspectionReq, void>(
    `${REACT_APP_SUBSCRIPTION}/tool-inspection/backoffice/set-inspection`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
